module.exports = __webpack_public_path__ + "static/60-8eda9703933d10c865a3a9ff4f15da14.png";